import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import PublishTradingOfferModalHeader from './components/PublishTradingOfferModalHeader';
import PublishTradingOfferModalBody from './components/PublishTradingOfferModalBody';
import PublishTradingOfferModalFooter from './components/PublishTradingOfferModalFooter';

import { usePublishTradingOfferModal } from './context/PublishTradingOfferModalContext';

const PublishTradingOfferModal: FC = () => {
  const { data } = usePublishTradingOfferModal();

  return (
    <>
      <PublishTradingOfferModalHeader />
      <PublishTradingOfferModalBody />
      <PublishTradingOfferModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default PublishTradingOfferModal;
